import { Component } from '@nicolas-riciotti/light2';
import Tween from '../../helpers/Tween';

export default class BlockHome extends Component {

    attached() {

        const $headlines = this.querySelectorAll('[data-headline]');
        const $nav       = this.querySelector('[slideshow-nav]');
        const $slides    = this.querySelectorAll('[data-slide]');
        
        $slides?.forEach(el => {

            if (el.hasAttribute('disabled')) {
                return;
            }
            
            el.addEventListener('click', e => {

                if (this.isTransitioning) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                this.isTransitioning = true;
                this.classList.add('is-transition');

                const $inner   = el.querySelector('[data-slide-inner]');
                const $img     = el.querySelector('[data-image]');
                const $title   = el.querySelector('[data-title]');
                const $link    = el.querySelector('[data-js-link]');

                const s        = window.innerWidth / $img.clientWidth;

                Tween({v:0}, {
                    to: {v:1},
                    easing: [0.43, 0.195, 0.02, 1],
                    duration: 2000,
                    step: value => {
                        $inner.style.transform = `scale(${1 + value * s})`;
                        $title.style.opacity = 1 - value;
                        if ($nav) {
                            $nav.style.opacity = 1 - Math.min(1, Math.max(0, value * 10));
                        }
                        $headlines?.forEach($headline => {
                            $headline.style.opacity = 1 - value;
                        });
                    },
                });

                setTimeout(()=>{
                    $link.click();
                }, 300)

            });
        });

        var $slideshow = this.querySelector('core-slideshow');
        // Mouse tilt — only on hover + fine-pointer devices, never on touch / low-end.
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var raf = null, tx = 0, ty = 0;
        function apply() {
            raf = null;
            $slideshow.style.setProperty('--bhs-tilt-x', tx.toFixed(2) + 'deg');
            $slideshow.style.setProperty('--bhs-tilt-y', ty.toFixed(2) + 'deg');
        }
        $slideshow.addEventListener('mousemove', function (e) {
            var r = $slideshow.getBoundingClientRect();
            tx = ((e.clientX - r.left) / r.width - 0.5) * 14;
            ty = -((e.clientY - r.top) / r.height - 0.5) * 14;
            if (!raf) raf = requestAnimationFrame(apply);
        });
        $slideshow.addEventListener('mouseleave', function () {
            tx = 0; ty = 0;
            if (!raf) raf = requestAnimationFrame(apply);
        });

    }

}

customElements.define('block-home', BlockHome);